import { render, staticRenderFns } from "./DetailProductPiping.vue?vue&type=template&id=74d681b2&"
import script from "./DetailProductPiping.vue?vue&type=script&lang=js&"
export * from "./DetailProductPiping.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductPiping.vue?vue&type=style&index=0&id=74d681b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports